var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10a9 9 0 11-18 0 9 9 0 0118 0z",
    fill: "#36B37E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.485 13.361a.436.436 0 00.334.149.453.453 0 00.335-.149l5.433-5.829a.537.537 0 000-.717l-.669-.716a.436.436 0 00-.334-.15.453.453 0 00-.334.15l-4.431 4.754-2.069-2.22a.436.436 0 00-.334-.148.453.453 0 00-.334.148l-.669.717a.537.537 0 000 .717l3.072 3.294z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default ForwardRef;